import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  ADD_NEW_EVENT,
  DELETE_EVENT,
    DELETE_MONTH_EVENTS,
  GET_CATEGORIES,
  GET_EVENTS,
  UPDATE_EVENT,
  GET_PROFILE,
  UPDATE_PROFILE
} from "./actionTypes"
import {
  getEventsSuccess,
  getEventsFail,
  addEventFail,
  addEventSuccess,
  updateEventSuccess,
  updateEventFail,
  deleteEventSuccess,
  deleteEventFail,
    deleteMonthEventsSuccess,
    deleteMonthEventsFail,
  getCategoriesSuccess,
  getCategoriesFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getEvents,
  getLoggedInUser,
  addNewEvent,
  updateEvent,
  deleteEvent,
    deleteMonthEvents,
  getCategories,
  postProfile
} from "../../helpers/fakebackend_helper"

function* fetchEvents() {
  try {
    console.log("ASDFAGDFSDGF")
    const user = getLoggedInUser()
    const response = yield call(getEvents, user)
    yield put(getEventsSuccess(response))
  } catch (error) {
    yield put(getEventsFail(error))
  }
}

function* onAddNewEvent({ payload: event }) {
  try {
    const response = yield call(addNewEvent, event)
    yield put(addEventSuccess(event))
  } catch (error) {
    yield put(addEventFail(error))
  }
}

function* onUpdateEvent({ payload: event }) {
  try {
    console.log("UPDATE EVENT", event);
    const response = yield call(updateEvent, event)
    yield put(updateEventSuccess(event))
  } catch (error) {
    yield put(updateEventFail(error))
  }
}

function* onDeleteEvent({ payload: eventId }) {
  try {
    const response = yield call(deleteEvent, eventId)
    yield put(deleteEventSuccess(eventId))
  } catch (error) {
    yield put(deleteEventFail(error))
  }
}

function* onBulkDeleteEvents({ payload: events }) {
  try {
    const response = yield call(deleteMonthEvents, events)
    const data = JSON.parse(response.body);
    const deletedIds = data.deletedIds;
    console.log("DELETED IDS", deletedIds);
    yield put(deleteMonthEventsSuccess(deletedIds))
  } catch (error) {
    yield put(deleteMonthEventsFail(error))
  }
}

function* onGetCategories() {
  try {
    const response = yield call(getCategories)
    yield put(getCategoriesSuccess(response))
  } catch (error) {
    yield put(getCategoriesFail(error))
  }
}

function* calendarSaga() {
  yield takeEvery(GET_EVENTS, fetchEvents)
  yield takeEvery(ADD_NEW_EVENT, onAddNewEvent)
  yield takeEvery(UPDATE_EVENT, onUpdateEvent)
  yield takeEvery(DELETE_EVENT, onDeleteEvent)
  yield takeEvery(DELETE_MONTH_EVENTS, onBulkDeleteEvents)
  yield takeEvery(GET_CATEGORIES, onGetCategories)
}

export default calendarSaga
